import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';

import { EVENT } from '../../../shared/constants/dali.constants';
import { FinancialModel } from '../../../shared/models/abre-cuentas.model';
import { Changes, TagEvent } from '../../../shared/models/dali-tags.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';

@Component({
  selector: 'app-form-goods',
  templateUrl: './form-goods.component.html',
  styleUrls: ['./form-goods.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormGoodsComponent implements OnInit {

  activeInput = false;
  formGroup: FormGroup;
  financialInfo: FinancialModel;
  reactiveErrorActive: string;
  reactiveErrorPassive: boolean;
  debt: any;

  config = {
    allowNegative: false,
    decimal: ',',
    precision: 0,
    thousands: '.',
    prefix: '$ ',
  };

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private taggingService: TaggingService,
    private navigationService: NavigationService,
    private helperService: HelpersService,
    public abreCuentasService: AbreCuentasService) {
    this.headerService.show(true, true, true);
  }
  ngOnInit() {
    this.financialInfo = this.abreCuentasService.getFinancialInfo();
    if (this.financialInfo.goods !== undefined && this.financialInfo.goods !== 0 && this.financialInfo.goods !== null) {
      this.activeInput = true;
    }
    if (!this.financialInfo.goods) {
      this.financialInfo.goods = null as any;
    }
    if (!this.financialInfo.debt) {
      this.financialInfo.debt = 0;
    }
    this.formGroup = new FormGroup({
      'input-value-active': new FormControl(this.financialInfo.goods, [Validators.required, Validators.min(10000), Validators.max(999999999999)]),
      'input-value-passive': new FormControl(this.financialInfo.debt, [Validators.required, Validators.min(0), Validators.max(999999999999)]),
    });
  }

  changeValue(event: any) {
    const value = event.target.value;
    const newvalue = this.helperService.currency(value);
    event.target.value = newvalue.format;
  }

  reactiveOnFocus() {
    this.activeInput = true;
  }

  /**
   * Summary Set validators to active Control
   */
  reactiveInputChangeActive() {
    if (this.abreCuentasService.viewOptionMultiProduct) {
      if (!this.activeInput) {
        return;
      }
      try {
        const controlActives = this.formGroup.controls['input-value-active'] as FormControl;
        let valor: string = this.formGroup.controls['input-value-active'].value
          ? this.formGroup.controls['input-value-active'].value : '';
        // valor = valor.replace('$ ', '').split(/\./).join('');
        this.reactiveErrorActive = controlActives.valid ? '' : 'Bienes mínimos $100.000 COP';
        if (+ valor >= 10000 && !isNaN(+ valor)) {
          this.reactiveErrorActive = '';
          return;
        }
        if (isNaN(+ valor)) {
          this.reactiveErrorActive = 'Bienes mínimos $100.000 COP';
          valor = valor.substring(0, valor.length - 1);
          if (!isNaN(+ valor) && + valor >= 100000) {
            this.reactiveErrorActive = '';
          }
          return;
        }
        if (+ valor < 100000) {
          this.reactiveErrorActive = 'Bienes mínimos $100.000 COP';
          return;
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      if (!this.activeInput) {
        return;
      }
      try {
        const controlActives = this.formGroup.controls['input-value-active'] as FormControl;
        let valor: string = this.formGroup.controls['input-value-active'].value
          ? this.formGroup.controls['input-value-active'].value : '';
        // valor = valor.replace('$ ', '').split(/\./).join('');
        this.reactiveErrorActive = controlActives.valid ? '' : 'Bienes mínimos $10.000 COP';
        if (+ valor >= 10000 && !isNaN(+ valor)) {
          this.reactiveErrorActive = '';
          return;
        }
        if (isNaN(+ valor)) {
          this.reactiveErrorActive = 'Bienes mínimos $10.000 COP';
          valor = valor.substring(0, valor.length - 1);
          if (!isNaN(+ valor) && + valor >= 10000) {
            this.reactiveErrorActive = '';
          }
          return;
        }
        if (+ valor < 10000) {
          this.reactiveErrorActive = 'Bienes mínimos $10.000 COP';
          return;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  defaultParameter(valor) {
    return valor === '' || valor === undefined ? '0' : valor;
  }

  /**
   * Summary Set validators to passive Control
   */
  reactiveInputChangePassive() {
    try {
      let valor: string = this.formGroup.controls['input-value-passive'].value ? this.formGroup.controls['input-value-passive'].value : '';
      valor = valor.replace('/[$]/', '').split(/\./).join('');
      valor = valor.split('$')[1];
      valor = this.defaultParameter(valor);
      if (!isNaN(+ valor) && valor !== '') {
        this.reactiveErrorPassive = true;
        this.debt = Number(valor);
        return;
      }
      this.reactiveErrorPassive = false;
      /* istanbul ignore else */
      if (isNaN(+ valor)) {
        this.reactiveErrorPassive = false;
        valor = valor.substring(0, valor.length - 1);
        if (!isNaN(+ valor) && + valor >= 0) {
          this.reactiveErrorPassive = true;
        }
        return;
      }

    } catch (error) {
      console.log(error);
    }
  }

  /**
   * change of input assets and liabilities, error validation
   */
  next() {
    const goods: string = this.formGroup.controls['input-value-active'].value;
    const debt: string = this.formGroup.controls['input-value-passive'].value;
    this.financialInfo.goods = +goods;
    this.financialInfo.debt = +debt;
    this.financialInfo.next = false;
    this.abreCuentasService.setFinancialInfo(this.financialInfo);
    this.tagNextButton();

    this.sendProspectFinancial();
  }

  sendProspectFinancial() {
    this.captureService.sendProspectFinancial(this.financialInfo).then(
      (response: any) => {
        if (response.status === 200) {
          this.navigationService.nextStep('200');
          return;
        }
        this.navigationService.navigateToGeneralInformation('500');
      },
    ).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  tagNextButton() {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E11setData`][`${tagPageName}E11transactionName`].path,
          value: EVENT[`${tagPageName}E11setData`][`${tagPageName}E11transactionName`].value,
        },
        {
          path: EVENT[`${tagPageName}E11setData`][`${tagPageName}E11transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E11setData`][`${tagPageName}E11transactionDetailsProductcategory`].value,
        },
      ];
      const customLabel = EVENT[`${tagPageName}E11customLabel`];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: customLabel[0]
          + ` | ${customLabel[1]} ${this.financialInfo.goods} | ${customLabel[2]} ${this.financialInfo.debt}`,
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (err) {
      console.log(err);
    }
  }

}
